import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import videoPredio from "../../assets/videos/DroneFree.webm";
import fallbackImage from "../../assets/images/logo-free-predio.webp";

// Hook dentro do componente
const useOnScreen = (ref, threshold = 0.1) => {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIntersecting(entry.isIntersecting),
      { threshold }
    );

    const current = ref.current;
    if (current) observer.observe(current);

    return () => {
      if (current) observer.unobserve(current);
    };
  }, [ref, threshold]);

  return isIntersecting;
};

const AboutSection = () => {
  const sectionRef = useRef(null);
  const isVisible = useOnScreen(sectionRef);

  return (
    <section
      ref={sectionRef}
      className={`py-16 transition-all duration-1000 ease-in-out ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center">
          <div className="lg:w-1/2 xl:w-[40%] 2xl:w-[35%] mb-10 lg:mb-0 mx-auto">
            <video
              src={videoPredio}
              poster={fallbackImage}
              autoPlay
              loop
              muted
              playsInline
              className="rounded-3xl shadow-lg w-full h-auto"
            />
          </div>
          <div className="lg:w-1/2 lg:pl-12 xl:pl-0 2xl:w-[55%]">
            <h2 className="text-3xl sm:text-4xl font-bold text-blue-950 mb-4">
              A Free Market Seguros
            </h2>

            <p className="text-lg sm:text-xl text-blue-950 mb-4">
              Desde 2003, a Free Market Seguros tem uma missão clara: proteger o
              que é mais valioso para você. Nascemos em São Gotardo (MG) e, com
              muito trabalho, ética e dedicação, crescemos para nos tornar uma
              das corretoras mais respeitadas da região, combinando a
              experiência de mais de duas décadas com soluções tecnológicas
              modernas para oferecer um atendimento ágil e personalizado.
            </p>

            <p className="text-lg sm:text-xl text-blue-950 mb-8">
              Para nós, cada cliente é único, e essa proximidade nos move a
              buscar sempre as melhores opções no mercado. Hoje, o resultado
              desse compromisso são as mais de
              <span className="font-bold"> 25 mil famílias protegidas</span> em
              todo o Brasil, um número que reflete a confiança depositada em
              nosso trabalho e reafirma nossa motivação para garantir a sua
              tranquilidade com segurança e um atendimento de excelência..
            </p>
            <Link
              to="/sobre"
              className="bg-blue-800 hover:bg-blue-950 text-white px-6 py-3 rounded-md font-medium inline-block"
            >
              Conheça Nossa História
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;